import React from 'react';
import './bootstrap';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import { createInertiaApp } from '@inertiajs/react';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@/components/theme-provider";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import Layout from '@/components/Layout.tsx';
import App from './App';
import "./i18n/i18n";

// Importez vos styles
import '../css/app.css'
import '../css/index.css'

const queryClient = new QueryClient();

// Liste des routes qui utiliseront le routage React
const REACT_ROUTED_PATHS = [
    '/search-engine',
    '/',
    '/dashboard',
    '/drh',
    '/formations',
    '/recruteurs',
    '/particuliers',
    '/rncp-presentation',
    '/meta-referentiel',
    '/contact',
    '/mentions-legales',
    '/politique-de-confidentialite',
    '/cgu'
].map(path => path.endsWith('/') ? path : path + '/'); // Ajoute un trailing slash à toutes les routes

const reactRouter = createBrowserRouter([
    {
        path: '/*',
        element: (
            <QueryClientProvider client={queryClient}>
                <ThemeProvider defaultTheme="system" enableSystem>
                    <TooltipProvider>
                        <Layout>
                            <Toaster />
                            <Sonner />
                            <App />
                        </Layout>
                    </TooltipProvider>
                </ThemeProvider>
            </QueryClientProvider>
        ),
    }
]);

const isReactRoute = (pathname) => {
    // Normalise le chemin en cours pour la comparaison
    const normalizedPath = pathname.endsWith('/') ? pathname : pathname + '/';
    return REACT_ROUTED_PATHS.some(path => normalizedPath.startsWith(path));
};

// Modifiez la vérification de la route
if (isReactRoute(window.location.pathname)) {
    const mountPoint = document.getElementById("root");
    if (mountPoint) {
        createRoot(mountPoint).render(
            <React.StrictMode>
                <RouterProvider router={reactRouter} />
            </React.StrictMode>
        );
    }
} else {
    // Sinon, initialisez Inertia
    createInertiaApp({
        resolve: name => {
            const pages = import.meta.glob('./Pages/**/*.jsx', { eager: true })
            return pages[`./Pages/${name}.jsx`]
        },
        setup({ el, App, props }) {
            createRoot(el).render(
                <App {...props} />
            );
        },
        progress: {
            color: '#4B5563',
        },
        title: title => `Skillengers - ${title}`
    });
} 